import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { TransferChallanOutModal } from '../model/index';

@Injectable()
export class TransferChallanOutService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    // private headers = new Headers({
    //    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

    //     //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    // });
    private transferChellOut = 'api/transferChallanOut';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getTcOutList(query: any): Promise<TransferChallanOutModal[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.transferChellOut}/getTcOutListDet`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getEditDetails(query: any): Promise<TransferChallanOutModal[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.transferChellOut}/getEditTcOutDet`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

     addTransferChellanOut(query: any): Promise<TransferChallanOutModal[]> {
        // let params: URLSearchParams = new URLSearchParams();
        // for (let key in query) {
        //     params.set(key.toString(), query[key]);
        // }

        // let options = new RequestOptions({
        //     headers: this.headers,
        //     search: params
        // });

        // const url = `${this.transferChellOut}/addTransChellOut`;
        // return this.http.get(url, options)
        //     .toPromise()
        //     .then(this.extractData)
        //     .catch(this.handleError);

        const url = `${this.transferChellOut}/addTransChellOut`;
        return this.http
            .post(url, $.param(query), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TransferChallanOutModal)
            .catch(this.handleError);
    }

     deleteTcOutGridList(rowData: any): Promise<TransferChallanOutModal> {
        const url = `${this.transferChellOut}/deleteTcOutGridList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TransferChallanOutModal)
            .catch(this.handleError);
    }

    deleteTcOut(rowData: any): Promise<TransferChallanOutModal> {
        const url = `${this.transferChellOut}/deleteTcOutList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TransferChallanOutModal)
            .catch(this.handleError);
    }

    getTransferChallanOutModelDetails(query: any): Promise<TransferChallanOutModal[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.transferChellOut}/getTransferChallanOutModelDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    UpdateTransFerChellanOut(testbilldetail: any): Promise<TransferChallanOutModal> {

        const url = `${this.transferChellOut}/updateTCOutData`;

        return this.http
            .post(url, $.param(testbilldetail), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TransferChallanOutModal)
            .catch(this.handleError);
    }

    addRowInEdit(testbilldetail: any): Promise<TransferChallanOutModal> {

        const url = `${this.transferChellOut}/addRowInEdit`;

        return this.http
            .post(url, $.param(testbilldetail), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TransferChallanOutModal)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/tcOut.service.ts